import React, { useState, useEffect, useContext } from "react"
import MetaTags from "react-meta-tags"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  TabContent,
  TabPane,
  Alert,
} from "reactstrap"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPInfoBox from "framework/layout/DPInfoBox"
//import TextValidation from "../../../framework/validators/TextValidation"
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//Import DPComponents
import DPNavBar from "../../../framework/widgets/DPNavBar"
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import VendorMasterTab1 from "./VendorMastergenaral"
import VendorMasterTab2 from "./VendorMastercontacs"
import VendorMasterTab3 from "./VendorMasterTax"
import VendorMasterTab4 from "./VendorMasterOrder"
import VendorMasterTab6 from "./VendorMasterledger"
import VenderMasterTab7 from "./VenderMasterEmail"
import VenderMasterTab8 from "./VenderMasterDocuments"

import DPLoadingAlert from "framework/widgets/DPLoadingAlert"
import DPPermission from "framework/widgets/DPPermission"
import DPPrintOption from "framework/widgets/DPPrintOptions"

import { Context } from "../../../app-contexts/CommonContexts"
import { useHistory } from "react-router-dom"
import VendorMasterLeadTime from "./VendorMasterLeadTime"
import { DeleteVenderMasterDetails, handleUploadSuppliers, SaveVendorMaster, VenderMasterDetailsGetData } from "./VenderControler"
import VendorBank from "./VenderBank"
import DPProductExcelUploadPopUp from "framework/components/DPProductExcelUploadPopUp"
import { MENUPERMISSION_SUPPLIER_ACTIVE } from "Permission_Rules"




const VendorMaster = props => {

  let history = useHistory()

  const vendorGroup = props.location.search.replace("?", "")

  //stateCodes for VenderMasterTab1
  const [strSupplierCode, SetCode] = useState("")
  const [strSupplierDesc, SetName] = useState("")
  const [strSupplierGroup, SetGroup] = useState("")
  const [strSupplierCategory, SetCategory] = useState("")
  const [strSupplierType, SetType] = useState("")
  const [strLinkRefe, SetLinkRef] = useState("")
  const [strGLCode, SetGLCode] = useState("")
  const [Status, SetActive] = useState(false)
  const [strBusRegistration, SetBusReg] = useState("")
  const [dbDiscount, SetStDiscount] = useState("0.0")
  const [dbContribution, SetStCount] = useState("0.0")
  const [strFolder, SetFileID] = useState("")
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [menuCode, SetMenuCode] = useState("")
  const [deleteEnable, SetDeleteEnable] = useState(false)
  const [handleClear, setHandleClear] = useState(false)
  const [skipApproval, setSkipApproval] = useState(false)
  const [bankDetails, setBankDetails] = useState({
    accountCode: "",
    bankName: "",
    bankCode: "",
    branchName: "",
    branchCode: "",
    payeeName: "",
    whtTax: 0
  })

  const bankDetailsValidation = {
    accountCode: (e) => Text(e.target, 20, true, false, 'any', false),
    bankName: (e) => Text(e.target, 100, true, false, 'any', true),
    bankCode: (e) => Text(e.target, 20, true, false, 'any', false),
    branchName: (e) => Text(e.target, 100, true, false, 'any', true),
    branchCode: (e) => Text(e.target, 20, true, false, 'any', false),
    payeeName: (e) => Text(e.target, 100, true, false, 'any', true),
    whtTax: (e) => {

      if (e.target.value == "") return 0

      const formatedVal = Numeric(e.target, 18, 2, false)

      if (formatedVal > 100) {
        return 100
      }
      return formatedVal
    },
  }


  const [disabled, setDisabled] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [show, setShow] = useState(false)
  const [AlertMsg, setAlertMsg] = useState("")
  const [AlertColor, setAlertColor] = useState("")
  const [saveBtnEnable, setSaveEnable] = useState(true)
  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  //stateCodes for VenderMasterTab2
  const [strAddress1, setAddress1] = useState("")
  const [strAddress2, setAddress2] = useState("")
  const [strAddress3, setAddress3] = useState("")
  const [strAddress4, setAddress4] = useState("")
  const [strArea, setSupArea] = useState("")
  const [strMobile1, setSupMobile1] = useState("")
  const [strMobile2, setSupMobile2] = useState("")
  const [strTelephone1, setSupMobile3] = useState("")
  const [strTelephone2, setSupMobile4] = useState("")
  const [strFax, setSupFax] = useState("")
  const [strEmail, setSupEmail] = useState("")
  const [strContactPerson, setSupContPerson] = useState("")
  const [strContactId, setSupContPersonID] = useState("")
  const [DataTables, SetDatatable] = useState([])
  const [addNew, setaddNew] = useState(true)
  const [handleNewClick, setHandleNewClick] = useState(false)
  //stateCodes for VenderMasterTab3
  const [arRow, setarRow] = useState([
    {
      id: 1,
      code: "",
      format: "",
      status: false,
      inc: false,
      taxCodeDisable: false,
      desc: "",
    },
  ])
  const [taxdetails, settaxdetails] = useState([])

  //stateCodes for VenderMasterTab4

  const [intOutletDirect, SetSwActive] = useState(false)
  const [intOrderCycle, SetOrderCycle] = useState(0)
  const [strOrderGroup, SetOrderGroup] = useState("")
  const [creditLimit, setCreditLimit] = useState(0)
  const [creditPeriod, setCreditPeriod] = useState(0)
  const [default_markup, setDefault_markup] = useState(0)

  //statecodes for VendorMasterTab 6
  const [ltime, setLeadTime] = useState([])

  //statecodes for VendorMasterTab 7
  const [tableData, setTableData] = useState([])

  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const [ErrorMsg, setErrorMsg] = useState("")

  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  //*****Menu Rights End */

  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  //autocode generation related newly added code
  const [codeButton, setCodeButton] = useState(true)
  const [searchdisabled, setSearchdisabled] = useState(false)
  const [nullCode, setNullCode] = useState(false)
  const [autoCode, setAutoCode] = useState(false)

  const [Reason, setReason] = useState("Created")
  const [editEnable, SetEditEnable] = useState(false)

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)
  const [printoptionShow, setprintoptionShow] = useState(false)

  //Documents Upload (VenderMasterDocuments)
  const [selectedAttachFiles, setSelectedAttachFiles] = useState([])
  const [attachFileNames, setAttachFileNames] = useState([]);
  const [clearAttachmentEdit, setClearAttachmentEdit] = useState(false)
  const [handleClearStatus, setHandleClearStatus] = useState(false)

  const [valueUpload, setvalueUpload] = useState("")
  const [file, setFile] = useState(null)


  const [excelSuccessResult, setExcelSuccessResult] = useState([])
  const [excelFailedResult, setExcelFailedResult] = useState([])
  const [toggleExcelUploadPopup, setToggleExcelUploadPopup] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [helpUrl, setHelpUrl] = useState("")
  //import from contexts
  const { fieldManager, getNonEditable, isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite, mobileNumberRegexp, emailRegexp, MenuUserpermission
  } =
    useContext(Context)
  //import from contexts


  var time = process.env.REACT_APP_ALERTTIMEOUT

  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")


  useEffect(() => {
    getNonEditable(menuCode)
  }, [menuCode])


  //**Get File Details */
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu =
      menuDetail && menuDetail.menuTag
        ? menuDetail.menuTag
        : history.push("/dashboard")
    var parentname = menuDetail?.parentName
    SetMenuCode(menu)

    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)

    var responseData = await getSelectedMasterPermissions(LogUserType, menu)

    if (!responseData.strMenuAccessRight) {
      history.push('/dashboard')
    }

    SetMenuAccess(responseData.strMenuAccessRight)
    SetMenuCreate(responseData.strMenuCreateRight)
    SetMenuDelete(responseData.strMenuDeleteRight)
    SetMenuModify(responseData.strMenuModifyRight)
    SetMenuPrint(responseData.strMenuPrintRight)
    SetMenuProcess(responseData.strMenuProcessRight)
    SetMenuName(responseData.strMenuName)
    SetMenuCode(responseData.strMenuTag)
    setPermissionReasonShow(responseData.strMenuReasonShow)
    setHelpUrl(responseData.strHelpUrl)

    getAutocode(menu)

  }, [])


  async function getAutocode(menu) {
    var autoCodeRes = await fetchAutoCode(menu)

    if (autoCodeRes.nullCode == false) {
      setAutoCode(autoCodeRes.autoCode)
    } else {
      setNullCode(true)
      setAutoCode("")
    }
  }



  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu =
      menuDetail && menuDetail.menuTag
        ? menuDetail.menuTag
        : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
  }, [])


  useEffect(() => {
    if (vendorGroup.length > 0) {
      SetCodeFind(vendorGroup)
    }
  }, [])





  //*** Get and Set values when user search code */
  async function SetCodeFind(CodeFind) {

    if (CodeFind == "") return

    if (validateSpecialCharacters(CodeFind) == true) {
      SetCode("")
      return
    }

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Fetching...")

    const result = await VenderMasterDetailsGetData(CodeFind);

    SetLoadingAlert(false)

    if (result.success == true) {

      let modifiedRows = []
      SetCode(result.data.code)
      SetName(result.data.name)
      SetGroup(result.data.strSupplierGroup)
      SetCategory(result.data.strSupplierCategory)
      SetType(result.data.strSupplierType)
      SetLinkRef(result.data.strLinkRefe)
      SetGLCode(result.data.strGLCode)
      SetBusReg(result.data.strBusRegistration)
      SetStDiscount(result.data.dbDiscount)
      SetStCount(result.data.dbContribution)
      SetFileID(result.data.strFolder)
      setAddress1(result.data.strAddress1)
      setAddress2(result.data.strAddress2)
      setAddress3(result.data.strAddress3)
      setAddress4(result.data.strAddress4)
      setSupArea(result.data.strArea)
      setSupMobile1(result.data.strMobile1)
      setSupMobile2(result.data.strMobile2)
      setSupMobile3(result.data.strTelephone1)
      setSupMobile4(result.data.strTelephone2)
      setSupFax(result.data.strFax)
      setSupEmail(result.data.strEmail)
      setSupContPerson(result.data.strContactPerson)
      setSupContPersonID(result.data.strContactId)
      SetOrderCycle(result.data.intOrderCycle)
      SetOrderGroup(result.data.strOrderGroup)
      SetSwActive(result.data.intOutletDirect)
      SetActive(result.data.status)
      setSkipApproval(result.data.skipApproval)
      setCrBy(result.data.createdBy)
      setMdBy(result.data.modifiedBy)
      setCrDate(result.data.createdDate)
      setMdDate(result.data.modifiedDate)
      setTableData(result.data.emailList)
      settaxdetails()
      setLeadTime(result.data.leadTimes)
      setCreditLimit(result.data.creditLimit)
      setCreditPeriod(result.data.creditPeriod)
      setBankDetails({
        accountCode: result.data.accountCode,
        bankName: result.data.bankName,
        bankCode: result.data.bankCode,
        branchName: result.data.branchName,
        branchCode: result.data.branchCode,
        payeeName: result.data.payee,
        whtTax: result.data.whTax
      })
      setDefault_markup(result.data.default_markup)
      setSelectedAttachFiles([])
      setAttachFileNames(result.data.supplierrAttachments)

      setHandleClear(prev => !prev)


      result.data.m_TBLTaxDetails.map((dr) => {
        modifiedRows.push({
          id: modifiedRows.length + 1,
          code: dr.taccode,
          desc: dr.taxdesc,
          format: dr.taxreg,
          status: dr.status,
          inc: dr.taxinc,
        })
      })
      setarRow(
        modifiedRows.length == undefined || modifiedRows.length == 0
          ? [{
            id: 1,
            code: "",
            format: "",
            status: false,
            inc: false,
            desc: "",
            taxCodeDisable: false,
          }]
          : modifiedRows
      );

      setaddNew(false)
      setDisabled(true)
      setDisabledCode(true)
      setSaveEnable(false)
      setCrEnable(true)
      SetDeleteEnable(true)
      setSearchdisabled(true)
      setReason("Updated")
      SetEditEnable(true)

    } else {
      if (nullCode == false) {
        setDisabledCode(true)
        displayAlertMessage('success', "Record Not Found !")
        SetCode("")
      } else {
        displayAlertMessage('success', "Record Not Found !")
      }
    }
  }
  //*** End useEffect */


  //**Recall and set values to relevant contrls based on the selected record from the search window  */
  const vender_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    SetCode(row.SM_CODE)
    SetCodeFind(row.SM_CODE)
    setDisabled(true)
    setDisabledCode(true)
    setSaveEnable(false)
    setmodal_xlarge(!modal_xlarge)
    setCrEnable(true)
  }

  //* Documents Save  */
  const Documents = () => {

    let TblLine = []
    attachFileNames.map((item, index) => {

      TblLine.push({
        intAHED_LINENO: parseInt(item.lineNo),
        strAHED_FILEPATH: item.fileName,
      })
    })
    return TblLine
  }
  //*End Attachment Save */

  // crud opperations
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  //Clear
  const ClearItem = () => {

    SetCode("")
    SetName("")
    SetGroup("")
    SetCategory("")
    SetType("")
    SetLinkRef("")
    SetGLCode("")
    SetBusReg("")
    SetStDiscount("0.0")
    SetStCount("0.0")
    SetFileID("")
    setDisabled(true)
    setDisabledCode(true)
    setAddress1("")
    setAddress2("")
    setAddress3("")
    setAddress4("")
    setSupArea("")
    setSupMobile1("")
    setSupMobile2("")
    setSupMobile3("")
    setSupMobile4("")
    setSupFax("")
    setSupEmail("")
    SetActive(false)
    setSkipApproval(false)
    setSupContPerson("")
    setSupContPersonID("")
    SetOrderCycle(0)
    SetOrderGroup("")
    setErrorMsg("")
    SetSwActive(false)
    setDisabledCode(false)
    setDisabled(false)
    setCrEnable(false)
    setCreditLimit(0)
    setCreditPeriod(0)
    setDefault_markup(0)
    setBankDetails({
      accountCode: "",
      bankName: "",
      bankCode: "",
      branchName: "",
      branchCode: "",
      payeeName: "",
      whtTax: 0
    })

    setarRow([
      {
        id: 1,
        code: "",
        format: "",
        status: false,
        inc: false,
        desc: "",
      },
    ])

    setSaveEnable(true)
    SetDeleteEnable(false)
    setHandleClear(prev => !prev)
    setNullCode(false)
    setSearchdisabled(false)
    setReason("Created")
    SetEditEnable(false)
    setSaveEnable(true)
    setPermissionName("")
    setPermissionPassword("")
    setPermissionNameDisable(false)
    setCodeButton(true)

    setLeadTime([])
    setTableData([])
    setcustomActiveTab("1")
    setCurrentPage(1)
    setHandleNewClick(!handleNewClick)
    setHandleClearStatus(prev => !prev)
    setFile(null)
    getAutocode(menuCode)

  }


  function handleAddRowNested() {
    const modifiedRows = [...arRow]
    modifiedRows.push({
      id: modifiedRows.length + 1,
      code: "",
      format: "",
      status: false,
      inc: false,
      desc: "",
    })

    var reArrangeID = modifiedRows.map((item, index) => item.id = index + 1)
    setarRow(reArrangeID)
  }

  function handleRemoveRow(id) {
    if (id !== 0) {
      var modifiedRows = [...arRow]
      modifiedRows = modifiedRows.filter(x => x["id"] != id)
      setarRow(modifiedRows)
    }
  }

  //Toolbar Fucntions
  const handleNew = e => {
    // e.preventDefault()
    ClearItem()
    setaddNew(true)
    setShow(false)
    setSaveEnable(true)

  }

  const handlesave = async e => {


    if (file != null) {

      try {
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Uploading Suppliers...")
        const { success, msg, successTable, unsuccessTable } = await handleUploadSuppliers(file, LogUserType, LocationCode)
        SetLoadingAlert(false)
        if (success) {
          displayAlertMessage('success', msg)
          setFile(null)
          setExcelSuccessResult(successTable)
          setExcelFailedResult(unsuccessTable)
          setToggleExcelUploadPopup(true)
        } else {
          displayAlertMessage('danger', msg)
          setFile(null)
          setExcelFailedResult([])
          setExcelSuccessResult([])
          setToggleExcelUploadPopup(false)
        }

      } catch (error) {
        SetLoadingAlert(false)
        setFile(null)
        setExcelFailedResult([])
        setExcelSuccessResult([])
        console.log('error', error)
      }



    } else {
      //set autogenerate code to as CODE just for display purpuse
      if (addNew == true && nullCode == false) {
        SetCode(autoCode)
      }

      //e.preventDefault()
      // validatoin codes
      var mobileNoPattern = new RegExp(mobileNumberRegexp)

      const newSupCode = addNew == true && nullCode == false ? autoCode : strSupplierCode

      if (newSupCode == "") {
        displayAlertMessage("danger", "Please Enter Supplier Code !")
        return
      }


      if (strSupplierCode == "" && nullCode == true) {
        displayAlertMessage("danger", "Please Enter Supplier Code !")
        return
      }
      if (strSupplierDesc == "") {
        displayAlertMessage("danger", "Please Enter Supplier Name !")
        return
      }
      if (strSupplierGroup == "") {
        displayAlertMessage('danger', "Please Enter Supplier  Group !")
        return
      }
      if (strSupplierCategory == "") {
        displayAlertMessage('danger', "Please Enter Supplier Category !")
        return
      }
      if (strSupplierType == "") {
        displayAlertMessage("danger", "Please Enter Supplier Type !")
        return
      }
      if (strAddress1 == "") {
        displayAlertMessage("danger", "Please Enter Supplier Address !")
        return
      }
      if (strArea == "") {
        displayAlertMessage("danger", "Please Enter Supplier Area !")
        return
      }
      if (strMobile1 == "") {
        displayAlertMessage("danger", "Please Enter Mobile number 1 !")
        return
      }

      if (strEmail !== "") {

        var emailPattern = new RegExp(emailRegexp)

        if (!emailPattern.test(strEmail)) {
          displayAlertMessage("danger", "Email is wrong")
          return
        }
      }

      if (selectedAttachFiles.length > 0) {
        displayAlertMessage("danger", `Please upload the selected files before save !`)
        setcustomActiveTab("8")
        return false
      }
      //;

      var TAXDETAILS = []

      for (var i = 0; i < arRow.length; i++) {
        if (arRow[i].code != "" && arRow[i].code != undefined) {
          if (arRow[i].format == "") {
            displayAlertMessage("danger", " Tax Registration could not be empty in table row number " + (i + 1) + " !")
            return
          }
          TAXDETAILS.push(
            taxDetBuilder(
              newSupCode,
              arRow[i].code,
              arRow[i].format,
              arRow[i].status,
              arRow[i].inc
            )
          )
        }
      }

      var supplierEmails = []

      tableData.map((index, value) => {
        supplierEmails.push({
          SUPCODE: newSupCode,
          TRTYPE: index.trtype,
          EMAIL: index.email,
          ACTIVE: index.active,
        })
      })

      const Suppliergenaral = {
        strSupplierCode: newSupCode,
        strSupplierDesc: strSupplierDesc,
        strSupplierGroup: strSupplierGroup,
        strSupplierCategory: strSupplierCategory,
        strSupplierType: strSupplierType,
        strLinkRefe: strLinkRefe,
        strGLCode: strGLCode,
        strBusRegistration: strBusRegistration,
        dbDiscount: parseFloat(dbDiscount),
        dbContribution: parseFloat(dbContribution),
        strFolder: strFolder,
        strAddress1: strAddress1,
        strAddress2: strAddress2,
        strAddress3: strAddress3,
        strAddress4: strAddress4,
        strArea: strArea,
        strMobile1: strMobile1,
        strMobile2: strMobile2,
        strTelephone1: strTelephone1,
        strTelephone2: strTelephone2,
        strFax: strFax,
        strEmail: strEmail,
        strContactPerson: strContactPerson,
        strContactId: strContactId,
        intOutletDirect: intOutletDirect,
        intOrderCycle: intOrderCycle,
        strOrderGroup: strOrderGroup,
        IsActive: Status,
        skipApproval: skipApproval,
        strMenuCode: menuCode,
        strLoggedCompany: LogCompanyCode,
        strLoggedLocation: LocationCode,
        strReason: Reason,
        strCreateBy: LogUserType,
        blAddNew: addNew,
        TAXDETAILS: TAXDETAILS,
        supTxnEmails: supplierEmails,
        attachmentsList: attachFileNames,
        creditLimit: parseFloat(creditLimit),
        creditPeriod: parseFloat(creditPeriod),
        default_markup: parseFloat(default_markup),
        bankName: bankDetails.bankName,
        bankCode: bankDetails.bankCode,
        branchName: bankDetails.branchName,
        branchCode: bankDetails.branchCode,
        accountCode: bankDetails.accountCode,
        payee: bankDetails.payeeName,
        whTax: parseFloat(bankDetails.whtTax)
      }

      //loading alert show
      SetLoadingAlert(true)
      if (addNew == true) {
        SetLoadingAlerttitle("Saving...")
      } else {
        SetLoadingAlerttitle("Updating...")
      }

      try {
        const result = await SaveVendorMaster(Suppliergenaral);

        if (result.success) {
          displayAlertMessage("success", result.data)
          ClearItem()
        } else {

          if (result.data == "Code Already Exist!") {
            displayAlertMessage("danger", result.data)
            setCodeButton(false)
          } else {
            displayAlertMessage("danger", result.data)
          }

        }
      } catch (error) {
        SetLoadingAlert(false)
        displayAlertMessage("danger", error.message)
      } finally {
        SetLoadingAlert(false)
      }



    }
  }




  const taxDetBuilder = (
    strSupplierCode,
    txtcode,
    txtformat,
    swstatus,
    swinc
  ) => {
    return {
      SUPCODE: strSupplierCode,
      TACCODE: txtcode,
      TAXREG: txtformat,
      STATUS: setIntFromBool(swstatus),
      TAXINC: setIntFromBool(swinc),
    }
  }

  const handleEdit = e => {
    setDisabled(false)
    setDisabledCode(true)
    setSaveEnable(true)
    setaddNew(false)
    SetDeleteEnable(true)
    SetEditEnable(false)
  }

  const setIntFromBool = blParameter => {
    if (blParameter) {
      return 1
    } else {
      return 0
    }
  }

  //********Delete button function */
  const handleDelete = async () => {


    const rowDelete = {
      strMenuCode: menuCode,
      strCode: strSupplierCode,
      strLoggedCompany: LogCompanyCode,
      strLoggedLocation: LocationCode,
      strReason: Reason,
      strCreateBy: crBy,
    }
    //loading alert show
    SetLoadingAlert(true)
    SetLoadingAlerttitle("Deleting...")

    const result = await DeleteVenderMasterDetails(rowDelete);

    SetLoadingAlert(false)

    if (result.success) {
      displayAlertMessage("success", result.data)
      ClearItem()

    } else {

      displayAlertMessage("danger", result.data)
    }

  }

  //*********Delete button function end */


  // print Function
  async function handlePrint(option) {
    var option = option
    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")
    const ReportURL = window.Links.ReportURL
    await fetch(
      `${ReportURL}api/Supplier/report/${option == "PDF" ? 1 : 0}/${LogUserType}/${menuCode}/${strSupplierCode}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
      .then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (option == "PDF") {
            const msg = responseData.msg
            window.open(
              `${ReportURL}temp_print/${msg.replace("\r\n", "")}.pdf`
            )
          }
          if (option == "XCEL") {
            const msg = responseData.msg
            window.open(
              `${ReportURL}temp_print/${msg.replace("\r\n", "")}.xls`
            )
          }
        }
        SetLoadingAlert(false)
      }).catch(error => {
        console.log(error.message)
        SetLoadingAlert(false)
      })
  }
  //functon for Tab navigation
  const [customActiveTab, setcustomActiveTab] = useState("1")
  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }

  //CODE AUTO GEN
  const AutoGenerateCode = async () => {
    await fetch(`${ApiURL}common/autocode/${menuCode}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (responseData.data.length > 0) {
            SetCode(responseData.data)
            setAutoCode(responseData.data)
          } else {
            setDisabledCode(false)
          }
        }
      })
  }

  const tabList = [
    {
      text: "General Information",
      icon: "fas fa-home",
      tabID: "1",
      onClick: () => {
        toggleCustom("1")
      },
    },
    {
      text: "Contact Details",
      icon: "far fa-user",
      tabID: "2",
      onClick: () => {
        toggleCustom("2")
      },
    },
    {
      text: "Tax Details",
      icon: "far fa-user",
      tabID: "3",
      onClick: () => {
        toggleCustom("3")
      },
    },
    {
      text: "Order Details",
      icon: "far fa-user",
      tabID: "4",
      onClick: () => {
        toggleCustom("4")
      },
    },
    {
      text: "Ledger Details",
      icon: "far fa-user",
      tabID: "5",
      onClick: () => {
        toggleCustom("5")
      },
    },
    {
      text: "Lead Time",
      icon: "far fa-user",
      tabID: "6",
      onClick: () => {
        toggleCustom("6")
      },
    },
    {
      text: "Email",
      icon: "far fa-user",
      tabID: "7",
      onClick: () => {
        toggleCustom("7")
      },
    },

    {
      text: "Documents",
      icon: "far fa-user",
      tabID: "8",
      onClick: () => {
        toggleCustom("8")
      },
    },
    {
      text: "Bank Details & Other",
      icon: "far fa-user",
      tabID: "9",
      onClick: () => {
        toggleCustom("9")
      },
    }
  ]

  //**Permission Check */
  const permission = operation => {
    const permissiondata = {
      strUsername: permissionName,
      strPassword: permissionPassword,
      strLocation: LocationCode,
      strMenuCode: menuCode,
    }

    clearPermissionInputs()

    fetch(`${ApiURL}login/userpermission`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(permissiondata),
    })
      .then(Response => {
        if (Response.status == "200") {
          Response.json().then(responseData => {
            let Access = responseData.data.strMenuAccessRight
            let Create = responseData.data.strMenuCreateRight
            let Delete = responseData.data.strMenuDeleteRight
            let Modify = responseData.data.strMenuModifyRight
            let Print = responseData.data.strMenuPrintRight
            let Process = responseData.data.strMenuProcessRight

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {
                if (operation == "Save" && addNew == true) {
                  displayAlertMessage('danger', "This user dosen't have permission to save")

                } else {
                  displayAlertMessage('danger', "This user dosen't have permission to edit")
                }
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")
              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")
              }
            }
          })
        } else if (Response.status == "400") {
          setDisabled(false)
          setDisabledCode(false)
          displayAlertMessage("danger", "Oops something went wrong !")
          clearPermissionInputs()

        } else if (Response.status == "403") {
          setDisabled(false)
          setDisabledCode(false)
          displayAlertMessage('danger', "You have not Permission to make changes !")
          clearPermissionInputs()

        } else if (Response.status == "404") {
          setDisabled(false)
          setDisabledCode(false)
          displayAlertMessage('danger', "Password or User Name is Invalid !")
          clearPermissionInputs()

        } else {
          ClearItem()
        }
      })
      .catch(error => {
        console.log(error.message)
      }).finally(() => {
        setPermissionPassword("")
      })
  }


  // Function for displaying Alert Messages.
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setShow(true)

    setTimeout(() => {
      setShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }

  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
  }


  const validateSpecialCharacters = (str) => {
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    return specialCharRegex.test(str);
  };


  function handleBankChanges(e) {
    const { name, value } = e.target;

    const validatedValue = bankDetailsValidation[name](e)

    // Get the event type from the nativeEvent (can be 'input' for onChange or 'focusout' for onBlur)
    const eventType = e.nativeEvent.type;

    if (eventType === 'focusout' && name == "whtTax") {

      setBankDetails(prevState => ({
        ...prevState,
        [name]: parseFloat(validatedValue)
      }))
      return;
    }

    setBankDetails(prevState => ({
      ...prevState,
      [name]: validatedValue
    }))
  }

  const ToggleExcelUploadPopup = () => {
    setToggleExcelUploadPopup(!toggleExcelUploadPopup)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title={parentName} breadcrumbItem={menuName} />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPAlert
                    confirm_both={sweetAlertShow}
                    title={menuName}
                    description={AlertDescription}
                    showCancel={true}
                    btnColor={"success"}
                    cancelColor={"danger"}
                    onConfirm={() => {
                      setsweetAlertShow(false)
                      if (AlertConfirmOption == 1) {
                        if (
                          addNew == true &&
                          menuCreate == true &&
                          permissionReasonShow == false
                        ) {
                          handlesave()
                        } else if (
                          addNew == true &&
                          menuCreate == true &&
                          permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Created", true, true)
                        } else if (
                          addNew == false &&
                          menuModify == true &&
                          permissionReasonShow == false
                        ) {
                          handlesave()
                        } else if (
                          addNew == false &&
                          menuModify == true &&
                          permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Updated", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      } else if (AlertConfirmOption == 2) {
                        handleEdit()
                      } else if (AlertConfirmOption == 3) {
                        history.push('/dashboard')
                      } else if (AlertConfirmOption == 4) {
                        handleNew()
                      } else if (AlertConfirmOption == 5) {
                        if (
                          addNew == false &&
                          menuDelete == true &&
                          permissionReasonShow == false
                        ) {
                          handleDelete()
                        } else if (
                          addNew == false &&
                          menuDelete == true &&
                          permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Deleted", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      } else if (AlertConfirmOption == 6) {
                        if (
                          menuPrint == true &&
                          permissionReasonShow == false
                        ) {
                          setprintoptionShow(true)
                        } else if (
                          menuPrint == true &&
                          permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Printed", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      }
                    }}
                    onCancel={() => {
                      setsweetAlertShow(false)
                    }}
                  />
                  <DPPermission
                    confirm_both={permissionAlertShow}
                    title={menuName}
                    description={permissionAlertTitle}
                    showReason={permissionReasonShow}
                    nameDisable={permissionNameDisable}
                    showCancel={true}
                    btnColor={"success"}
                    cancelColor={"danger"}
                    AlName={permissionName}
                    AlNameOnchange={e => {
                      let val2 = Text(e.target, 50, true, false, "any", true)
                      setPermissionName(val2)
                    }}
                    AlPassward={permissionPassword}
                    AlPasswardOnchange={e => {
                      let val2 = Text(e.target, 50, true, true, "any", true)
                      setPermissionPassword(val2)
                    }}
                    AlReason={Reason}
                    AlReasonOnchange={e => {
                      let val2 = Text(e.target, 50, true, false, "any", true)
                      setReason(val2)
                    }}
                    onConfirm={async () => {
                      setPermissionAlertShow(false)
                      if (AlertConfirmOption == 1) {
                        permission("Save")
                      } else if (AlertConfirmOption == 5) {
                        permission("Delete")
                      } else if (AlertConfirmOption == 6) {
                        permission("Print")
                      } else if (AlertConfirmOption == 10) {

                        try {

                          SetLoadingAlert(true)
                          SetLoadingAlerttitle("Permission Checking...")

                          const permissonResponse = await MenuUserpermission(permissionName, permissionPassword, MENUPERMISSION_SUPPLIER_ACTIVE)
                          if (permissonResponse?.strMenuAccessRight == true) {
                            SetActive(true)
                          } else {
                            displayAlertMessage('danger', "This User don't have permission to activate this field !")
                          }
                          setPermissionPassword("")
                        } catch {
                          displayAlertMessage('danger', "This User don't have permission to activate this field !")
                        } finally {
                          SetLoadingAlert(false)
                        }

                      } else if (AlertConfirmOption == 11) {

                        try {

                          SetLoadingAlert(true)
                          SetLoadingAlerttitle("Permission Checking...")

                          const permissonResponse = await MenuUserpermission(permissionName, permissionPassword, "S00407")
                          if (permissonResponse?.strMenuAccessRight == true) {
                            setSkipApproval(true)
                          } else {
                            displayAlertMessage('danger', "This User don't have permission to activate this field !")
                          }
                          setPermissionPassword("")
                        } catch {
                          displayAlertMessage('danger', "This User don't have permission to activate this field !")
                        } finally {
                          SetLoadingAlert(false)
                        }

                      }
                    }}
                    onCancel={() => {
                      setPermissionAlertShow(false)
                      setPermissionPassword("")
                      clearPermissionInputs()
                    }}
                  />
                  <DPPrintOption
                    confirm_both={printoptionShow}
                    title={menuName}
                    showCancel={true}
                    cancelColor={"danger"}
                    onConfirmpdf={() => {
                      handlePrint("PDF")
                      setprintoptionShow(false)
                    }}
                    onConfirmxcel={() => {
                      handlePrint("XCEL")
                      setprintoptionShow(false)
                    }}
                    onCancel={() => {
                      setprintoptionShow(false)
                    }}
                  />
                  <DPLoadingAlert
                    confirm_both={loadingAlert}
                    title={loadingAlertTitle}
                  />
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      handleNew,
                        setAlertDescription(
                          "Do you wish to refresh the screen ?"
                        )
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveBtnEnable && isHeadOffice}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?")
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={editEnable && isHeadOffice}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?")
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    //Print Button
                    printEnable={true}
                    printClick={() => {
                      setReason("Printed")
                      setAlertDescription("Do you wish to Print ?")
                      setAlertConfirmOption(6)
                      setsweetAlertShow(true)
                    }}
                    //Delete Button
                    deleteEnable={deleteEnable}
                    deleteClick={() => {
                      setReason("Deleted")
                      setAlertDescription("Do you wish to delete ?")
                      setAlertConfirmOption(5)
                      setsweetAlertShow(true)
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?")
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />
                  <DPNavBar buttons={tabList} activeStatus={customActiveTab} />
                  <TabContent activeTab={customActiveTab} className="p-3 text">
                    {show ? (
                      <Alert color={AlertColor} role="alert">
                        {AlertMsg}
                        <br />
                        <small>{ErrorMsg}</small>
                      </Alert>
                    ) : null}

                    {file ? (
                      <Alert color={"secondary"} role="alert">
                        {"Excel File selected click save to upload "}
                      </Alert>
                    ) : null}

                    <DPProductExcelUploadPopUp
                      isOpen={toggleExcelUploadPopup}
                      mainTitle={"Supplier Excel upload Results"}
                      excelFailedResult={excelFailedResult}
                      excelSuccessResult={excelSuccessResult}
                      toggle={ToggleExcelUploadPopup}
                    />

                    <TabPane tabId="1">
                      <VendorMasterTab1
                        fieldManager={
                          fieldManager[menuCode]
                            ? fieldManager[menuCode]
                            : { hidden: false, disable: [] }
                        }
                        vender_SelectRowSearch={vender_SelectRowSearch}
                        CodeValue={strSupplierCode}
                        CodeonChange={e => {
                          let val1 = Text(
                            e.target,
                            10,
                            true,
                            false,
                            "upper",
                            false
                          )
                          SetCode(val1)
                        }}
                        CodeFind={e => {
                          SetCodeFind(e.target.value)
                        }}
                        NameValue={strSupplierDesc}
                        NameonChange={e => {
                          let val2 = Text(
                            e.target,
                            50,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetName(val2)
                        }}
                        GroupValue={strSupplierGroup}
                        GrouponChange={val3 => {
                          SetGroup(val3["value"])
                        }}
                        CategoryValue={strSupplierCategory}
                        CategoryonChange={val4 => {
                          SetCategory(val4["value"])
                        }}
                        TypeValue={strSupplierType}
                        TypeonChange={val5 => {
                          SetType(val5["value"])
                        }}
                        LinkRefValue={strLinkRefe}
                        LinkRefonChange={e => {
                          let val6 = Text(
                            e.target,
                            30,
                            true,
                            true,
                            "any",
                            false
                          )
                          SetLinkRef(val6)
                        }}
                        GLCodeValue={strGLCode}
                        GLCodeonChange={e => {
                          let val7 = Text(
                            e.target,
                            30,
                            true,
                            true,
                            "any",
                            false
                          )
                          SetGLCode(val7)
                        }}
                        StatusSw={Status}
                        SwonChange={(e) => {

                          if (e) {
                            setPermissionAlertShow(true)
                            setPermissionNameDisable(false)
                            setPermissionName("")
                            setAlertConfirmOption(10)
                          } else {
                            SetActive(e)
                          }

                        }}
                        BusRegValue={strBusRegistration}
                        BusRegonChange={e => {
                          let val8 = Text(
                            e.target,
                            e.target,
                            50,
                            true,
                            true,
                            "any",
                            false
                          )
                          SetBusReg(val8)
                        }}
                        StDiscountValue={dbDiscount}
                        StDiscountonChange={e => {
                          let val9 = Numeric(e.target, 10, 2, false)
                          if (val9 <= 100) {
                            SetStDiscount(val9)
                          } else {
                            SetStDiscount("0.0")
                          }
                        }}
                        StDiscountonBlur={e => {
                          let stdiscount = DecimalValidation(e.target.value)
                          SetStDiscount(stdiscount)
                        }}
                        StContValue={dbContribution}
                        StContonChange={e => {
                          let val10 = Numeric(e.target, 10, 2, false)
                          if (val10 <= 100) {
                            SetStCount(val10)
                          } else {
                            SetStCount("0.0")
                          }
                        }}
                        StContonBlur={e => {
                          let stConton = DecimalValidation(e.target.value)
                          SetStCount(stConton)
                        }}
                        FileIDValue={strFolder}
                        FileIDonChange={e => {
                          let val11 = Text(
                            e.target,
                            10,
                            true,
                            true,
                            "amy",
                            false
                          )
                          SetFileID(val11)
                        }}
                        modelTrigger={tog_xlarge}
                        modelOpen={modal_xlarge}
                        disabled={disabled}
                        disabledCode={disabledCode}
                        AlertColor={AlertColor}
                        AlertMsg={AlertMsg}
                        ErrorMsg={ErrorMsg}
                        DataTables={DataTables}
                        vender_CodeSearchTrigger={tog_xlarge}
                        vender_CodeSearchOpen={modal_xlarge}
                        menuName={menuName}
                        onButtonClick={e => {
                          AutoGenerateCode()
                          setCodeButton(true)
                        }}
                        btnDisable={codeButton}
                        SearchDisable={searchdisabled}
                        showFileUpload={e => {
                          const file = e.target.files[0];
                          setFile(file)
                        }}
                        valueUpload={valueUpload}
                        menuCode={menuCode}
                        autoCode={autoCode}
                        setDefault_markup={(e) => {
                          let defMarkup = Numeric(e.target, 10, 2, false)
                          if (defMarkup > 100) {
                            setDefault_markup(100)
                          } else if (defMarkup < 0) {
                            setDefault_markup(0)
                          } else {
                            setDefault_markup(defMarkup)
                          }

                        }}
                        setDefault_markupOnblur={(e) => {
                          let defMarkup = DecimalValidation(e.target.value, true, 2)
                          setDefault_markup(defMarkup)

                        }}
                        default_markup={default_markup}
                        skipApproval={skipApproval}
                        setSkipApproval={(e) => {
                          if (e) {
                            setPermissionAlertShow(true)
                            setPermissionNameDisable(false)
                            setPermissionName("")
                            setAlertConfirmOption(11)
                          } else {
                            setSkipApproval(e)
                          }

                        }}
                      />
                    </TabPane>
                    <TabPane tabId="2">
                      <VendorMasterTab2
                        fieldManager={
                          fieldManager[menuCode]
                            ? fieldManager[menuCode]
                            : { hidden: false, disable: [] }
                        }
                        Address1Value={strAddress1}
                        Address1onChange={e => {
                          let val1 = Text(
                            e.target,
                            50,
                            true,
                            true,
                            "any",
                            true
                          )
                          setAddress1(val1)
                        }}
                        Address2Value={strAddress2}
                        Address2onChange={e => {
                          let val2 = Text(
                            e.target,
                            50,
                            true,
                            true,
                            "any",
                            true
                          )
                          setAddress2(val2)
                        }}
                        Address3Value={strAddress3}
                        Address3onChange={e => {
                          let val3 = Text(
                            e.target,
                            50,
                            true,
                            true,
                            "any",
                            true
                          )
                          setAddress3(val3)
                        }}
                        Address4Value={strAddress4}
                        Address4onChange={e => {
                          let val4 = Text(
                            e.target,
                            50,
                            true,
                            true,
                            "any",
                            true
                          )
                          setAddress4(val4)
                        }}
                        SupAreaValue={strArea}
                        SupAreaonChange={val5 => {
                          setSupArea(val5["value"])
                        }}
                        Mobile1Value={strMobile1}
                        Mobile1onChange={e => {
                          let inputValue = Text(e.target, 15, true, true, "any", false)

                          // Remove '+' from the middle of the input
                          if (inputValue.indexOf('+') !== 0) {
                            inputValue = inputValue.replace(/\+/g, '');
                          }

                          // Allow only numbers and a single '+' at the beginning
                          const sanitizedValue = inputValue.replace(/[^0-9+]/g, '');

                          // Length validation (e.g., limit to 10 characters)
                          if (sanitizedValue.length <= 15) {
                            setSupMobile1(sanitizedValue);
                          }

                        }}
                        Mobile2Value={strMobile2}
                        Mobile2onChange={e => {
                          let inputValue = Text(e.target, 15, true, true, "any", false)

                          // Remove '+' from the middle of the input
                          if (inputValue.indexOf('+') !== 0) {
                            inputValue = inputValue.replace(/\+/g, '');
                          }

                          // Allow only numbers and a single '+' at the beginning
                          const sanitizedValue = inputValue.replace(/[^0-9+]/g, '');

                          // Length validation (e.g., limit to 10 characters)
                          if (sanitizedValue.length <= 15) {
                            setSupMobile2(sanitizedValue);
                          }
                        }}
                        Mobile3Value={strTelephone1}
                        Mobile3onChange={e => {
                          let inputValue = Text(e.target, 15, true, true, "any", false)

                          // Remove '+' from the middle of the input
                          if (inputValue.indexOf('+') !== 0) {
                            inputValue = inputValue.replace(/\+/g, '');
                          }

                          // Allow only numbers and a single '+' at the beginning
                          const sanitizedValue = inputValue.replace(/[^0-9+]/g, '');

                          // Length validation (e.g., limit to 10 characters)
                          if (sanitizedValue.length <= 15) {
                            setSupMobile3(sanitizedValue);
                          }

                        }}
                        Mobile4Value={strTelephone2}
                        Mobile4onChange={e => {
                          let inputValue = Text(e.target, 15, true, true, "any", false)

                          // Remove '+' from the middle of the input
                          if (inputValue.indexOf('+') !== 0) {
                            inputValue = inputValue.replace(/\+/g, '');
                          }

                          // Allow only numbers and a single '+' at the beginning
                          const sanitizedValue = inputValue.replace(/[^0-9+]/g, '');

                          // Length validation (e.g., limit to 10 characters)
                          if (sanitizedValue.length <= 15) {
                            setSupMobile4(sanitizedValue);
                          }
                        }}
                        FaxValue={strFax}
                        FaxonChange={e => {
                          let val29 = Text(e.target, 15, true, true, "any", false)
                          setSupFax(val29)
                        }}
                        EmailValue={strEmail}
                        EmailonChange={e => {

                          let val30 = Text(e.target, 100, true, true, "any", false)
                          setSupEmail(val30)
                        }}
                        ContPersonValue={strContactPerson}
                        ContPersononChange={e => {
                          let val11 = Text(
                            e.target,
                            50,
                            true,
                            false,
                            "any",
                            true
                          )
                          setSupContPerson(val11)
                        }}
                        ContPersonIDValue={strContactId}
                        ContPersonIDonChange={e => {
                          let val12 = Text(
                            e.target,
                            10,
                            true,
                            true,
                            "upper",
                            false
                          )
                          setSupContPersonID(val12)
                        }}
                        modelTrigger={tog_xlarge}
                        modelOpen={modal_xlarge}
                        disabled={disabled}
                        disabledCode={disabledCode}
                        AlertColor={AlertColor}
                        AlertMsg={AlertMsg}
                        ErrorMsg={ErrorMsg}
                      />
                    </TabPane>
                    <TabPane tabId="3">
                      <VendorMasterTab3
                        fieldManager={
                          fieldManager[menuCode]
                            ? fieldManager[menuCode]
                            : { hidden: false, disable: [] }
                        }
                        modelTrigger={tog_xlarge}
                        modelOpen={modal_xlarge}
                        disabled={disabled}
                        disabledCode={disabledCode}
                        AlertColor={AlertColor}
                        AlertMsg={AlertMsg}
                        ErrorMsg={ErrorMsg}
                        DataRow={arRow}
                        setarRow={setarRow}
                        RemoveRow={handleRemoveRow}
                        AddRow={handleAddRowNested}
                        menuCode={menuCode}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </TabPane>
                    <TabPane tabId="4">
                      <VendorMasterTab4
                        fieldManager={
                          fieldManager[menuCode]
                            ? fieldManager[menuCode]
                            : { hidden: false, disable: [] }
                        }
                        ErrorMsg={ErrorMsg}
                        disabled={disabled}
                        intOutletDirect={intOutletDirect}
                        SwonActiveChange={() => {
                          SetSwActive(!intOutletDirect)
                        }}
                        intOrderCycleValue={intOrderCycle}
                        intOrderCycleonChange={e => {
                          let val25 = Numeric(e.target, 4, false, false)
                          SetOrderCycle(+val25)
                        }}
                        strOrderGroupValue={strOrderGroup}
                        strOrderGrouponChange={e => {
                          let val12 = Text(
                            e.target,
                            5,
                            true,
                            false,
                            "any",
                            true
                          )
                          SetOrderGroup(val12)
                        }}
                        modelTrigger={tog_xlarge}
                        modelOpen={modal_xlarge}
                        disabledCode={disabledCode}
                        AlertColor={AlertColor}
                        AlertMsg={AlertMsg}
                        setCreditLimitOnchange={e => {
                          let val = Numeric(e.target, 18, 2, false)
                          setCreditLimit(val)
                        }}
                        CreditLimitValue={creditLimit}
                        setCreditLimitOnBlur={e => {
                          let creditLimit = DecimalValidation(e.target.value, 0, true, 2)
                          setCreditLimit(creditLimit)
                        }}

                        setCreditPeriodOnchange={e => {
                          let val = Numeric(e.target, 18, 0, false)
                          setCreditPeriod(val)
                        }}
                        CreditPeriodValue={creditPeriod}
                        setCreditPeriodOnBlur={e => {
                          let creditPeriod = DecimalValidation(e.target.value, 0, false, 0)
                          setCreditPeriod(creditPeriod)
                        }}



                      ></VendorMasterTab4>
                    </TabPane>

                    <TabPane tabId="5">
                      <VendorMasterTab6
                        strSupplierCode={strSupplierCode}
                        handleClear={handleClear}
                      ></VendorMasterTab6>
                    </TabPane>

                    <TabPane tabId="6">
                      <VendorMasterLeadTime
                        ltime={ltime}
                        handleClear={handleClear}
                      />
                    </TabPane>

                    <TabPane tabId="7">
                      <VenderMasterTab7
                        setAlertColor={setAlertColor}
                        setAlertMsg={setAlertMsg}
                        setShow={setShow}
                        setTableData={setTableData}
                        tableData={tableData}
                        disabled={disabled}
                        handleNewClick={handleNewClick}
                      />
                    </TabPane>

                    <TabPane tabId="8">
                      <VenderMasterTab8
                        selectedAttachFiles={selectedAttachFiles}
                        setAttachFileNames={setAttachFileNames}
                        attachFileNames={attachFileNames}
                        setSelectedAttachFiles={setSelectedAttachFiles}
                        clearStatus={handleClearStatus}
                        disable={disabled}
                        clearAttachmentEdit={clearAttachmentEdit}
                      />
                    </TabPane>
                    <TabPane tabId="9">
                      <VendorBank
                        fieldManager={
                          fieldManager[menuCode]
                            ? fieldManager[menuCode]
                            : { hidden: false, disable: [] }
                        }
                        disabled={disabled}
                        AlertColor={AlertColor}
                        AlertMsg={AlertMsg}
                        ErrorMsg={ErrorMsg}
                        handleBankChanges={handleBankChanges}
                        bankDetails={bankDetails}
                      />
                    </TabPane>
                  </TabContent>
                  <Row>
                    {/* infor box */}
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={
                          crDate != "1900-01-01 00:00:00"
                            ? crDate
                              ? crDate.replace("T", " ")
                              : ""
                            : ""
                        }
                        modifiedBy={mdBy}
                        modifiedOn={
                          mdDate != "1900-01-01 00:00:00"
                            ? mdDate
                              ? mdDate.replace("T", " ")
                              : ""
                            : ""
                        }
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default VendorMaster